import React, { useState, useEffect } from "react";
import {
  Select,
  Breadcrumb,
  Divider,
  Button,
  Card,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Space,
  Popconfirm,
  Badge
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import AddEditTemplateContentDialog from "./AddEditTemplateContentDialog";
import templateContentService from "../../services/template-content-service";
import CustomTable from '../../components/table/custom-table';
import { useCreatedSort, withCreatedColumn } from '../../shared/functional/created-sort';
import constantService from '../../services/constant-service';
import { sortor } from "../../shared/functional/func-table"
import userService from "../../services/user-service";

const { Panel } = Collapse;

function callback(key) {
  // console.log(key);
}

const TemplateContent = () => {
  const dispatch = useDispatch();
  const [editData, setEditData] = useState(null);
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [condition, setCondition] = useState({ title: null });
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, rowPerPage: 10, rowCount: 0 });
  const [templateType, setTemplateType] = useState([]);
  const [templateList, setTemplateList] = useState(null);
  const [userList, setUserList] = useState([]);


  /*
    NMU-580: the วันที่/เวลาสร้าง column and the sort behind it.

    The server does the ordering — this table shows one page of many — so a
    click re-runs the search in the new order, back on page 1: the newest
    record is not on page 3 of the same list read the other way round.
  */
  const { sort, createdColumn, onChangeTable } = useCreatedSort((next) =>
    doSearch(1, { condition, templateList, sort: next }));

  const columns = [
    {
      title: "ชื่อเนื้อหา",
      key: "title",
      // sorter: (a, b) => a.mainTitle.titleTH.value - b.mainTitle.titleTH.value,
      render: ({ mainTitle }) => {
        return <span>{mainTitle?.titleTH}</span>;
      },
    },
    {
      title: "รูปแบบเนื้อหา",
      key: "templateType",
      dataIndex: 'templateType',
      // sorter: sortor("templateType"),
      render: (data) => {
        let val = templateType.find((item) => item.value === data);
        if (val) {
          return <span>{val.labelEn}</span>;
        }
      }
    },
    {
      title: "ผู้บันทึก",
      key: "createBy",
      dataIndex: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: "จำนวนผู้เข้าชม",
      key: "totalView",
      // sorter: (a, b) => a.totalView - b.totalView,
      render: ({ totalView }) => {
        return <span>{totalView ? totalView : 0}</span>;
      },
    },
    {
      title: 'ดำเนินการ',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <Space size="middle">
          <a onClick={() => onClickEdit(record)} className="pe-3 border-end">
            <Icon.Edit size={18} />
          </a>
          <a onClick={() => onClickCopy(record)} className="pe-3 border-end">
            <Icon.Link size={18} />
          </a>

          <Popconfirm
            title="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onConfirmDelete(record.templateId)}
            okText="ยืนยัน"
            cancelText="ยกเลิก" >
            <a >
              <Icon.Trash size={18} />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const { templateType } = await constantService.getTemplateType();
      templateType.forEach((x) => {
        x.value = parseInt(x.value);
      });
      setTemplateType(templateType);

      const response = await userService.search();
      setUserList(response.list);
    }
    initData();
    doSearch(1);
  }, []);

  useEffect(() => {
    if (editData) {
      onEdit(editData);
    }
  }, [editData]);

  const onAdd = () => {
    setEditData(null);
    setIsShowAddFileDialog(true);
  };

  const onCancel = () => {
    setIsShowAddFileDialog(false);
    setEditData(null);
  };

  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch(1);
  };

  const onEdit = (data) => {
    setEditData(data);
    setIsShowAddFileDialog(true);
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  }

  const renderTemplateTypeOption = () => {
    return templateType?.map((item) => {
      return (
        <Select.Option value={item.value} key={item.value}>
          {item.labelEn}
        </Select.Option>
      );
    });
  };
  
  const onTemplateChange = () => {

    return (value) => {
      setTemplateType(value);
    };
  }


  /**
   * @param currentPage page to land on, 1 to start over.
   * @param overrides   NMU-529: search with these filters instead of the ones in
   *   state. setCondition only takes effect on the next render, so a caller that
   *   resets the filters and searches in the same handler would otherwise re-run
   *   the search it just cleared.
   */
  const doSearch = async (currentPage, overrides) => {
    try {
      const activeSort = overrides && overrides.sort ? overrides.sort : sort;
      const newPaginate = {
        ...pagination,
        currentPage: currentPage ? currentPage : pagination.currentPage,
        // NMU-580: the order travels with the page — see created-sort.js.
        ...activeSort,
      };

      dispatch(appLoaderAction.enable());

      const activeCondition = overrides ? overrides.condition : condition;
      const activeTemplateList = overrides ? overrides.templateList : templateList;

      // NMU-579: keywordList is no longer a search condition. The backend skips
      // the criterion when it is absent, so nothing else changes.
      const newCondition = {
        title: activeCondition.title,
        templateType: activeTemplateList,
        createBy: activeCondition.createBy,
      }

      const result = await templateContentService.search(newCondition, newPaginate);
      setDataList(result.list);
      setPagination(result.pagination ? result.pagination : newPaginate);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  /**
   * NMU-529: clearing the filters has to re-run the search, not just empty the
   * inputs — otherwise the table keeps showing the previous result set while the
   * form claims no filter is applied. Back to page 1, since the record the user
   * was looking at on page 3 of a filtered list is somewhere else entirely in
   * the full one.
   */
  const onClearSearch = () => {
    const cleared = { title: null, createBy: null };
    setCondition(cleared);
    setTemplateList(null);
    doSearch(1, { condition: cleared, templateList: null });
  }

  /**
   * NMU-544: load the page before editing it, rather than editing the table row.
   *
   * This used to hand the search result straight to the dialog. NMU-536 then
   * excluded `content` from that enquiry — correctly: the grid shows titles, and
   * the body is 1.14 MB per page on production data. But the edit form reads
   * `editData.content[0]`, so the row it was handed now carried `content: null`
   * and the form threw on open, taking the whole admin down to a white screen.
   *
   * The quieter half is why a null-guard alone would not have been a fix: the
   * form seeds its rich-text editors from that same `content[0]`, and `บันทึก`
   * writes whatever they hold. An editor who opened a page after the crash was
   * guarded would have seen an empty body and saved it over a real one.
   *
   * `getById` deliberately has no projection, so this is the one read that
   * carries the body — which is exactly what the form needs and the grid does
   * not. The News page has always done it this way.
   */
  const onClickEdit = async (record) => {
    try {
      dispatch(appLoaderAction.enable());
      const result = await templateContentService.getById({ id: record.templateId });
      setEditData(result.bean);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onClickCopy = (record) => {
    try {
      navigator.clipboard.writeText(record.url);
      notifyUtitls.success('สำเร็จ', 'คัดลอกลิ้งค์');
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onConfirmDelete = (id) => {
    onDelete(id);
  }

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());

      await templateContentService.remove({ deleteIds: [id] });
      dispatch(appLoaderAction.disale());
      notifyUtitls.deleted('สำเร็จ', 'ลบข้อมูลสำเร็จ');
      doSearch(1);
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };
  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null
      }
    });
  };

  const onChangePage = (currentPage) => {
    doSearch(currentPage);
  }
  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  }

  return (
    <div>
      <h2 className="color-primary-title">เนื้อหา</h2>
      <Breadcrumb>
        <Breadcrumb.Item>จัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>เนื้อหา</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <div>
          {/* <Button type="primary">
            <Icon.Save className="me-1" size={18} /> Save
          </Button> */}
          {/* <Button className="mx-2 btn-line">Reset Menu</Button> */}
        </div>
        <Button type="primary" className="mx-2" htmlType="button" onClick={() => onAdd()}>
          <Icon.Plus className="me-1" size={18} /> เพิ่มเนื้อหา
        </Button>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={8}>
                    <Form.Item label="ชื่อเนื้อหา" className="mb-0">
                      <Input
                        name="title"
                        value={condition.title}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  {/* NMU-579: no คีย์เวิร์ด filter here. Keywords are something
                      an editor sets on a page in the add/edit dialog — they were
                      never a useful way to find one. The dialog keeps its
                      keyword input. */}
                  <Col span={8}>
                    <Form.Item label="ประเภทเนื้อหา" className="mb-0" >

                      <Select
                        name="templateList"
                        customWidth="100%"
                        onChange={(labelEn) => setTemplateList(labelEn)}
                        value={templateList}>
                        <Select.Option value={null}>ทั้งหมด</Select.Option>
                        {renderTemplateTypeOption()}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect('createBy')}
                      >
                        {renderOptionUser()}

                      </Select>
                    </Form.Item>
                  </Col>

                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch(1)}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <CustomTable
          rowKey="templateId"
          tableName="templateTable"
          columns={withCreatedColumn(columns, createdColumn)}
          onChangeTable={onChangeTable}
          data={dataList}
          scroll={{ x: true }}
          isPagination={true}
          onChangePage={onChangePage}
          currentPage={pagination.currentPage}
          pageSize={pagination.rowPerPage}
          totalRecord={pagination.rowCount}
        />
      </Card>

      <AddEditTemplateContentDialog
        isShow={isShowAddFileDialog}
        editData={editData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}></AddEditTemplateContentDialog>
    </div>
  );
};

export default TemplateContent;
